import { configureStore } from '@reduxjs/toolkit';
import rolesReducer from './slices/rolesSlice';
import countriesReducer from './slices/countriesSlice';
import departmentsReducer from './slices/departmentsSlice';
import designationsReducer from './slices/designationsSlice';
import gradesReducer from './slices/gradesSlice';
import leaveTypesReducer from './slices/leaveTypesSlice';
import levelsReducer from './slices/levelsSlice';

export const store = configureStore({
  reducer: {
    roles: rolesReducer,
    countries: countriesReducer,
    departments: departmentsReducer,
    designations: designationsReducer,
    grades: gradesReducer,
    leaveTypes: leaveTypesReducer,
    levels: levelsReducer,
  },
});

export default store;
